import './Footer.css'
function Footer(){
    return (
        <footer className='App-footer'>
        <h4>Made with ❤️ by Loukik</h4>
        </footer>
    );
}
export default Footer;